import { useMutation, useApolloClient } from '@apollo/client';
import ASSIGNED_LANDLORDS, { FIND_LANDLORDS, SIGNUP_LANDLORD } from '../queries';
import { message } from 'antd';
import { useState } from 'react';

export function useAddAllLandlord() {
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();

  const [signupLandlord] = useMutation(SIGNUP_LANDLORD, { refetchQueries: [ASSIGNED_LANDLORDS] });

  const addAllLandlord = async () => {
    try {
      setLoading(true);
      const landlordsResponse = await client.query({
        query: FIND_LANDLORDS,
        fetchPolicy: 'no-cache',
      });

      const landlords = landlordsResponse?.data?.listManageLandlords?.landlords || [];
      if (landlords.length) {
        await signupLandlord({
          variables: {
            input: { landlordIds: landlords.map(landlord => landlord.id) },
          },
        });
      } else {
        message.warning('No Landlords available.');
      }
      setLoading(false);
    } catch (error) {
      message.warning(error);
    } finally {
      setLoading(false);
    }
  };
  return { addAllLandlord, loading };
}
